import { render, staticRenderFns } from "./PhoneVerification.vue?vue&type=template&id=6813c55e"
import script from "./PhoneVerification.vue?vue&type=script&lang=js"
export * from "./PhoneVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6813c55e')) {
      api.createRecord('6813c55e', component.options)
    } else {
      api.reload('6813c55e', component.options)
    }
    module.hot.accept("./PhoneVerification.vue?vue&type=template&id=6813c55e", function () {
      api.rerender('6813c55e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/ContactVerification/components/PhoneVerification.vue"
export default component.exports